import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import isEqual from 'lodash/isEqual'

import {
  getFormattedTimezoneDate,
  getNowInTimezone,
  getTimezoneDate,
  isLocalPeriodId,
  scrollToTop,
  calculateFees,
} from '../../../utilities/helpers'
import {
  createOrEditOffers,
  createOrEditConnectedOffer,
} from '../../../utilities/api'

import Alert from 'react-bootstrap/Alert'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'

import { BackButton } from '../../BackButton'
import { WarningCard } from '../../WarningCard'
import { Details } from './Details'
import { Inventory } from './Inventory'
import { PricingFees } from './PricingFees'
import { Availability } from './Availability'
import { AccessCode } from './AccessCode'
import { TicketLimits } from './TicketLimits'
import { CreateEventButtons } from '../../CreateEventButtons'
import { DeleteModal } from '../../DeleteModal'
import { GoToSeatMapModal } from './GoToSeatMapModal'
import { OpenOffers } from './OpenOffers'
import { ConfirmLeaveModal } from './ConfirmLeaveModal'
import { InputGroup } from 'react-bootstrap'
import AuthService from '../../../utilities/services/auth.service'
import UserContext from '../../../context/User/User'

export default function CreateOfferWrapper({
  isEventPublishing,
  isEventSoldout,
  hasEventEnded,
  eventId,
  event,
  openInventory,
  isSpecialtyOffer,
  id,
  offers,
  currentOffer,
  standardAdmissionOfferHasInventory,
  setIsChangesMade,
  getDiscountedPrice,
  getAvailabilityPeriods,
  getOfferPrice,
  getOfferStatus,
  getSeatCount,
  removeOffer,
  isRemoving,
}) {
  // BOX OFFICE
  const { user } = useContext(UserContext)
  const redeemFlexTicketsOnline = Boolean(
    AuthService.getOrg()?.[0]?.setting?.redeemVouchersOnline
  )
  const [priceAdjustment, setPriceAdjustment] = useState('')
  // BOX OFFICE END

  const navigate = useNavigate()
  // go to seat map popup
  const [show, setShow] = useState(false)

  // delete popup
  const [showDelete, setShowDelete] = useState(false)

  // confirm leave popup
  const [showConfirm, setShowConfirm] = useState(false)

  const [isStandard, setIsStandard] = useState(false)

  // editing existing offer
  const [isEditing, setIsEditing] = useState(false)

  // can edit fields - will be true if creating new offer
  const [canEdit, setCanEdit] = useState(true)

  const [initialState, setInitialState] = useState()

  const [offer, setOffer] = useState({})

  const [inventory, setInventory] = useState({})

  const [priceLevels, setPriceLevels] = useState({})

  const [pricingOpt, setPricingOpt] = useState(null)

  const [discount, setDiscount] = useState('')

  const [availabilityPeriodId, setAvailabilityPeriodId] = useState(null)

  // flag to check if single access code tab is selected for validations
  const [hasAccessCode, setHasAccessCode] = useState(false)

  // flag to check if exact ticket limit tab is selected for validations
  const [hasExactLimit, setHasExactLimit] = useState(false)

  const [ticketLimits, setTicketLimits] = useState({
    hasMinQuantity: false,
    minQuantity: '',
    hasMaxQuantity: false,
    maxQuantity: '',
    hasMultipleOfQuantity: false,
    multipleOfQuantity: '',
    limit: '',
  })

  const [errors, setErrors] = useState([])

  const [taxRates, setTaxRates] = useState({
    stateRate: 0,
    estimatedCityRate: 0,
  })

  // offer that specialty offer is based on
  const [baseOffer, setBaseOffer] = useState()

  const [showFooter, setShowFooter] = useState(false)

  const [isSaving, setIsSaving] = useState(false)

  // newly created offer id - to pass to go to seatmap popup
  const [newOfferId, setNewOfferId] = useState()

  const [alert, setAlert] = useState({
    show: false,
    variant: '',
    message: '',
  })

  const [hasRequiredFieldError, setHasRequiredFieldError] = useState(false)

  const [requiredFieldErrorStatus, setRequiredFieldErrorStatus] = useState({})

  useEffect(() => {}, [eventId])

  useEffect(() => {
    // showLoading()
    if (!event?.venue.address) {
      // hideLoading()
      return
    }
    setTaxRates(event.taxRate)
  }, [event])

  useEffect(() => {
    setIsEditing(Boolean(id))
  }, [id])

  useEffect(() => {
    // can edit fields when editing/viewing offer

    // true - create offer
    // true - edit offer
    // false - view offer
    let availabilityPeriods = isSpecialtyOffer
      ? baseOffer?.availability
      : offer?.availabilityPeriods
    if (availabilityPeriods) {
      const activePeriod = availabilityPeriods?.find((period) => period.active)
      if (isEditing) {
        if (activePeriod) {
          // can edit if the offer has not ended and is not sold out
          const periodStatus = getOfferStatus(activePeriod, offer)?.type
          setCanEdit(
            (offer?.status !== 'ended' || periodStatus !== 'ended') &&
              !offer?.isSoldOut
          )
        }
      }
    }
  }, [isEditing, offer, baseOffer, event])

  useEffect(() => {
    // add price levels to offers
    // if new offer, get price levels from standard admission
    const getPriceLevels = () => {
      let priceLevels = {}
      let levels = {}

      if (offers) {
        // if new offer, offer gets Standard Admission price levels
        if (!currentOffer) {
          levels = offers[0]?.am_pricing_objects
        }

        // existing offer
        else {
          levels = currentOffer?.am_pricing_objects
        }

        const sortPriceLevels = (levels) => {
          return Object.values(levels).sort((a, b) => {
            const numA = parseInt(a.name.replace(/\D/g, ''), 10)
            const numB = parseInt(b.name.replace(/\D/g, ''), 10)
            return numA - numB
          })
        }
        const sorted = sortPriceLevels(levels)

        // create price levels
        sorted?.map((level, idx) => {
          priceLevels[idx + 1] = {
            id: level?.id,
            name: level?.name,
            color: level?.color,
            seats: level?.seats,
            isIncluded: true,
            description: level?.description || '',
            basePrice: level?.basePrice?.toString(),
            offerPrice: currentOffer
              ? getOfferPrice(
                  sorted,
                  idx,
                  currentOffer?.pricing_option,
                  currentOffer?.discount
                )
              : level?.offerPrice?.toString(),
            fee: currentOffer
              ? level?.fee?.toString()
              : event?.facilityFees?.toString(),
            serviceFee: level?.serviceFee,
            serviceFees: level?.serviceFee,
            ticketFacilityFee: level?.ticketFacilityFee,
            paymentProcessingFee: level?.paymentProcessingFee,
            salesTax: level?.salesTax,
            taxPerTicket: level?.taxPerTicket,
            chargeBackProtection: level?.chargeBackProtection,
            totalDue: level?.totalDue,
            ticketCostWithFees: level?.ticketCostWithFees,
            ticketCostWithFeesAndTax: level?.ticketCostWithFeesAndTax,
            totalFees: level?.totalFees,
            combinedTaxRate: level?.combinedTaxRate,
          }
        })
      }

      return priceLevels
    }

    const getOffer = (offer) => {
      return {
        id: offer?.id,
        uuid: offer?.uuid,
        eventUUID: eventId,
        status:
          offer?.status ||
          (currentOffer &&
            getOfferStatus(
              getAvailabilityPeriods(currentOffer)?.find(
                (period) => period.active
              ),
              currentOffer
            )?.type),
        name: offer?.name || '',
        description: offer?.description || '',
        availabilityPeriods: getAvailabilityPeriods(currentOffer),
        accessCode: offer?.accessCode || '',
        isSoldOut: offer?.isSoldOut ?? false,
        isHidden: offer?.isHidden ?? false,
        freeOffer: offer?.freeOffer ?? false,
        redeemWithVouchersOnline: offer?.redeemWithVouchersOnline ?? false,
      }
    }

    const getSelected = (periods) => {
      return periods?.find((period) => period.active)?.id
    }

    // save initial state to check whether to show footer
    let offer = getOffer(currentOffer)
    // compare offer[0] id to offer id
    setIsStandard(offers && offers[0]?.id === offer?.id)
    const priceLevels = getPriceLevels()
    const defaultPriceLevels = priceLevels
    setPriceLevels(priceLevels)
    const discount = currentOffer?.discount || ''
    let formattedDiscount = discount
    if (discount) {
      if (currentOffer?.pricing_option === 'decrease_by_price') {
        formattedDiscount = currentOffer?.discount.toFixed(2)
      }
    }
    setDiscount(formattedDiscount)
    const pricingOption = currentOffer?.pricing_option || 'match_price'
    setPricingOpt(pricingOption)
    setAvailabilityPeriodId(getSelected(offer?.availabilityPeriods))
    const hasAccessCode = Boolean(offer?.accessCode)
    setHasAccessCode(hasAccessCode)
    const hasMinQuantity = currentOffer?.hasMinQuantity ?? false
    const minQuantity = currentOffer?.minQuantity ?? ''
    const hasMaxQuantity = currentOffer?.hasMaxQuantity ?? false
    const maxQuantity = currentOffer?.maxQuantity ?? ''
    const hasMultipleOfQuantity = currentOffer?.hasMultipleOfQuantity ?? false
    const multipleOfQuantity = currentOffer?.multipleOf ?? ''
    const limit = currentOffer?.limit ?? ''
    const hasExactLimit = Boolean(limit)
    setHasExactLimit(hasExactLimit)
    setTicketLimits({
      hasMinQuantity,
      minQuantity,
      hasMaxQuantity,
      maxQuantity,
      hasMultipleOfQuantity,
      multipleOfQuantity,
      limit,
    })

    // A new offer and an open offer share the open pool. An exclusive offer
    // keeps only its own seats, including an empty list.
    const isOpenInventory =
      !currentOffer || currentOffer?.inventoryType?.toLowerCase() === 'open'

    const inventory = {
      id: currentOffer?.id,
      uuid: currentOffer?.uuid,
      type: isOpenInventory ? 'open' : 'exclusive',
      color: currentOffer?.color || openInventory?.color,
      seats: isOpenInventory
        ? openInventory?.seats || []
        : currentOffer?.seats || [],
      gaSeats: isOpenInventory
        ? openInventory?.gaSeats || {}
        : currentOffer?.gaSeats || {},
    }

    setInventory(inventory)

    // get base offer - default is Standard Admission
    let baseOffer
    let priceAdjustment
    if (isSpecialtyOffer) {
      // if editing
      if (currentOffer) {
        // find which offer has current offer
        baseOffer = offers?.find((offer) =>
          offer.connected_offers?.some(
            (connected) => connected.id === Number(currentOffer?.id)
          )
        )
        let updatedBaseOffer = {
          ...baseOffer,
          availability: getAvailabilityPeriods(baseOffer),
        }

        baseOffer = updatedBaseOffer

        // update soldout and hidden status of specialty offer based on base offer
        // if parent offer is hidden, force specialty offer to hidden
        // if parent offer is not hidden, leave as is
        offer = {
          ...offer,
          isSoldOut: baseOffer?.isSoldOut,
          isHidden: baseOffer?.isHidden ? baseOffer?.isHidden : offer?.isHidden,
        }
      } else {
        // base offer is Standard Admission offer by default
        baseOffer = offers[0]
      }
      setBaseOffer(baseOffer)
      // get price adjustment amount
      priceAdjustment = currentOffer?.priceAdjustmentAmount
      setPriceAdjustment(priceAdjustment)
    }

    setOffer((prevState) => ({
      ...prevState,
      ...offer,
    }))

    // set state
    saveInitialState(
      offer,
      inventory,
      defaultPriceLevels,
      priceLevels,
      pricingOption,
      formattedDiscount,
      getSelected(offer?.availabilityPeriods),
      hasAccessCode,
      hasMinQuantity,
      minQuantity,
      hasMaxQuantity,
      maxQuantity,
      hasMultipleOfQuantity,
      multipleOfQuantity,
      hasExactLimit,
      limit,
      { baseOffer, priceAdjustment }
    )
  }, [eventId, event, currentOffer, isSpecialtyOffer, offers, openInventory])

  useEffect(() => {
    // creating new specialty offer
    if (!currentOffer && isSpecialtyOffer) {
      if (baseOffer) {
        // update specialty offer base offer when base offer changes
        // update soldout and hidden status of specialty offer based on base offer
        const offer = {
          isSoldOut: baseOffer?.isSoldOut,
          isHidden: baseOffer?.isHidden,
        }

        setOffer((prevState) => ({
          ...prevState,
          ...offer,
        }))

        // update state
        setInitialState((prevState) => ({
          ...prevState,
          offer: {
            ...prevState?.offer,
            ...offer,
          },
        }))
      }
    }
  }, [currentOffer, isSpecialtyOffer, baseOffer])

  // set show footer
  useEffect(() => {
    // check if availability periods have changed from initial state
    const hasPeriodsChanged = (offer, initialPeriods) => {
      const periods = offer?.availabilityPeriods
      // Check if lengths are different
      if (periods.length !== initialPeriods.length) {
        return true // Arrays are different
      }

      // Compare each period using `some` to find any difference
      return periods.some((period, index) => {
        const initialPeriod = initialPeriods[index]

        // Assuming periods have `starts` and `ends` properties that need comparison
        return (
          !isEqual(period.name, initialPeriod.name) ||
          !isEqual(
            new Date(getFormattedTimezoneDate(period.starts, event?.timezone)),
            new Date(
              getFormattedTimezoneDate(initialPeriod.starts, event?.timezone)
            )
          ) ||
          !isEqual(
            new Date(getFormattedTimezoneDate(period.ends, event?.timezone)),
            new Date(
              getFormattedTimezoneDate(initialPeriod.ends, event?.timezone)
            )
          )
        )
      })
    }

    setShowFooter(
      !isEqual(offer?.name, initialState?.offer?.name) ||
        !isEqual(offer?.isHidden, initialState?.offer?.isHidden) ||
        !isEqual(offer?.freeOffer, initialState?.offer?.freeOffer) ||
        !isEqual(
          offer?.redeemWithVouchersOnline,
          initialState?.offer?.redeemWithVouchersOnline
        ) ||
        !isEqual(offer?.description, initialState?.offer?.description) ||
        !isEqual(pricingOpt, initialState?.pricingOpt) ||
        !isEqual(priceLevels, initialState?.priceLevels) ||
        (!isSpecialtyOffer &&
          (!isEqual(availabilityPeriodId, initialState?.availabilityPeriodId) ||
            hasPeriodsChanged(
              offer,
              initialState?.offer?.availabilityPeriods
            ))) ||
        !isEqual(hasAccessCode, initialState?.hasAccessCode) ||
        !isEqual(offer?.accessCode, initialState?.offer?.accessCode) ||
        !isEqual(
          ticketLimits?.hasMinQuantity,
          initialState?.ticketLimits?.hasMinQuantity
        ) ||
        !isEqual(
          parseInt(ticketLimits?.minQuantity),
          parseInt(initialState?.ticketLimits?.minQuantity)
        ) ||
        !isEqual(
          ticketLimits?.hasMaxQuantity,
          initialState?.ticketLimits?.hasMaxQuantity
        ) ||
        !isEqual(
          parseInt(ticketLimits?.maxQuantity),
          parseInt(initialState?.ticketLimits?.maxQuantity)
        ) ||
        !isEqual(
          ticketLimits?.hasMultipleOfQuantity,
          initialState?.ticketLimits?.hasMultipleOfQuantity
        ) ||
        !isEqual(
          parseInt(ticketLimits?.multipleOfQuantity),
          parseInt(initialState?.ticketLimits?.multipleOfQuantity)
        ) ||
        !isEqual(hasExactLimit, initialState?.hasExactLimit) ||
        !isEqual(
          parseInt(ticketLimits?.limit),
          parseInt(initialState?.ticketLimits?.limit)
        ) ||
        (isSpecialtyOffer &&
          !isEqual(baseOffer?.id, initialState?.baseOffer?.id)) ||
        (isSpecialtyOffer &&
          !isEqual(
            parseFloat(priceAdjustment),
            parseFloat(initialState?.priceAdjustment)
          ))
    )
  }, [
    initialState,
    offer?.name,
    offer?.description,
    offer?.isHidden,
    offer?.freeOffer,
    offer?.redeemWithVouchersOnline,
    pricingOpt,
    priceLevels,
    availabilityPeriodId,
    offer?.availabilityPeriods,
    hasAccessCode,
    offer?.accessCode,
    ticketLimits?.hasMinQuantity,
    ticketLimits?.minQuantity,
    ticketLimits?.hasMaxQuantity,
    ticketLimits?.maxQuantity,
    ticketLimits?.hasMultipleOfQuantity,
    ticketLimits?.multipleOfQuantity,
    hasExactLimit,
    ticketLimits?.limit,
    isSpecialtyOffer,
    baseOffer,
    priceAdjustment,
  ])

  useEffect(() => {
    if (hasRequiredFieldError) {
      // if all fields are filled in: reset required field state
      if (
        Object.keys(requiredFieldErrorStatus).every(
          (key) => !requiredFieldErrorStatus[key]
        )
      ) {
        closeAlert()
        setHasRequiredFieldError(false)
        setRequiredFieldErrorStatus({})
      }
    }
  }, [hasRequiredFieldError, requiredFieldErrorStatus])

  useEffect(() => {
    // close all alerts when fields are edited if no errors and there is no required field error
    if (alert.show && errors?.length === 0 && !hasRequiredFieldError) {
      closeAlert()
    }
  }, [
    offer?.name,
    offer?.description,
    offer?.isHidden,
    offer?.freeOffer,
    offer?.redeemWithVouchersOnline,
    pricingOpt,
    priceLevels,
    availabilityPeriodId,
    offer?.availabilityPeriods,
    hasAccessCode,
    offer?.accessCode,
    ticketLimits?.hasMinQuantity,
    ticketLimits?.minQuantity,
    ticketLimits?.hasMaxQuantity,
    ticketLimits?.maxQuantity,
    ticketLimits?.hasMultipleOfQuantity,
    ticketLimits?.multipleOfQuantity,
    hasExactLimit,
    ticketLimits?.limit,
    baseOffer,
    priceAdjustment,
  ])

  useEffect(() => {
    if (hasRequiredFieldError) {
      updateRequiredFieldErrorStatus()
    }
  }, [
    offer?.name,
    offer?.freeOffer,
    discount,
    pricingOpt,
    hasAccessCode,
    offer.accessCode,
    ticketLimits.hasMinQuantity,
    ticketLimits?.minQuantity,
    ticketLimits?.hasMaxQuantity,
    ticketLimits?.maxQuantity,
    ticketLimits?.hasMultipleOfQuantity,
    ticketLimits?.multipleOfQuantity,
    hasExactLimit,
    ticketLimits?.limit,
  ])

  useEffect(() => {
    // change offer price when discount changes
    // only if creating new or editing offer and discount or price levels are not the same as initial state
    if (offer?.freeOffer) return
    if (canEdit) {
      if (priceLevels && initialState?.priceLevels) {
        if (
          !isEqual(parseFloat(discount), parseFloat(initialState?.discount)) ||
          !isPriceSameAsInitial(priceLevels, initialState?.priceLevels)
        ) {
          let updatedPriceLevels = { ...priceLevels }
          // always discount off of base price - discount of default price
          for (const [key] of Object.entries(
            initialState?.defaultPriceLevels
          )) {
            let price = initialState?.defaultPriceLevels[key].basePrice
            price = getDiscountedPrice(price, pricingOpt, discount || 0)
            const nextLevel = {
              ...updatedPriceLevels[key],
              offerPrice: price.toString(),
            }
            const calculatedFees = calculateFees(
              nextLevel,
              event?.fee_structure,
              taxRates,
              event
            )
            const serviceFee =
              calculatedFees?.serviceFee ??
              calculatedFees?.serviceFees ??
              nextLevel?.serviceFee ??
              nextLevel?.serviceFees ??
              0

            updatedPriceLevels = {
              ...updatedPriceLevels,
              [key]: {
                ...nextLevel,
                ...calculatedFees,
                serviceFee,
                serviceFees: serviceFee,
              },
            }
          }
          setPriceLevels({ ...updatedPriceLevels })
        }
      }
    }
  }, [
    canEdit,
    initialState?.priceLevels,
    initialState?.discount,
    discount,
    pricingOpt,
    event,
    taxRates,
    offer?.freeOffer,
  ])

  // reset price levels back to default (Standard Admission offer) every time pricing option changes
  // only if creating new or editing offer and pricing option or offer price is not same as initial state
  useEffect(() => {
    if (offer?.freeOffer) return
    if (canEdit) {
      if (
        (pricingOpt &&
          initialState?.pricingOpt &&
          !isEqual(pricingOpt, initialState?.pricingOpt)) ||
        (Object.keys(priceLevels)?.length > 0 &&
          Object.keys(initialState?.priceLevels)?.length > 0 &&
          !isPriceSameAsInitial(priceLevels, initialState?.priceLevels))
      ) {
        if (initialState?.defaultPriceLevels) {
          let defaultPriceLevels = { ...priceLevels }
          setDiscount('')
          for (const [key, value] of Object.entries(
            initialState?.defaultPriceLevels
          )) {
            const price = value.basePrice
            const nextLevel = {
              ...defaultPriceLevels[key],
              offerPrice: price.toString(),
            }
            const calculatedFees = calculateFees(
              nextLevel,
              event?.fee_structure,
              taxRates,
              event
            )
            const serviceFee =
              calculatedFees?.serviceFee ??
              calculatedFees?.serviceFees ??
              nextLevel?.serviceFee ??
              nextLevel?.serviceFees ??
              0
            defaultPriceLevels = {
              ...defaultPriceLevels,
              [key]: {
                ...nextLevel,
                ...calculatedFees,
                serviceFee,
                serviceFees: serviceFee,
              },
            }
          }

          setPriceLevels({ ...defaultPriceLevels })

          // remove input error when input field changes
          if (findError('discount')) resetError('discount')
        }
      }
    }
  }, [
    canEdit,
    pricingOpt,
    initialState?.pricingOpt,
    initialState?.defaultPriceLevels,
    initialState?.priceLevels,
    event,
    taxRates,
    offer?.freeOffer,
  ])

  // change price level seats everytime inventory changes
  // if not editing offer and inventory or price levels are not the same as initial state
  // have to check inventory and price levels since inventory could be the same as initial state when switching between "Open" and "Custom"
  useEffect(() => {
    if (!isSpecialtyOffer && initialState?.priceLevels && priceLevels) {
      if (!isEditing) {
        if (inventory && Object.values(inventory)?.length > 0) {
          if (
            !isEqual(inventory, initialState?.inventory) ||
            !isSeatsSameAsInitial(priceLevels, initialState?.priceLevels)
          ) {
            let updatedPriceLevels = { ...priceLevels }
            for (const [key, value] of Object.entries(
              initialState?.priceLevels
            )) {
              updatedPriceLevels = {
                ...updatedPriceLevels,
                [key]: {
                  ...updatedPriceLevels[key],
                  seats:
                    inventory?.type === 'open'
                      ? value?.seats
                      : getSeatCount(inventory),
                },
              }
            }

            setPriceLevels({ ...updatedPriceLevels })
          }
        }
      }
    }
  }, [
    isSpecialtyOffer,
    isEditing,
    initialState?.priceLevels,
    inventory,
    initialState?.inventory,
  ])

  // Keep computed pricing fields in sync for new offers, including after
  // scaling-inventory-to-event updates that only mutate seats/price levels.
  useEffect(() => {
    if (offer?.freeOffer) return
    if (isEditing) return
    if (!event?.fee_structure || !taxRates) return
    if (!priceLevels || Object.keys(priceLevels).length === 0) return

    const recomputedPriceLevels = Object.entries(priceLevels).reduce(
      (acc, [key, level]) => {
        const calculatedFees = calculateFees(
          level,
          event?.fee_structure,
          taxRates,
          event
        )
        const serviceFee =
          calculatedFees?.serviceFee ??
          calculatedFees?.serviceFees ??
          level?.serviceFee ??
          level?.serviceFees ??
          0

        acc[key] = {
          ...level,
          ...calculatedFees,
          serviceFee,
          serviceFees: serviceFee,
        }

        return acc
      },
      {}
    )

    if (!isEqual(recomputedPriceLevels, priceLevels)) {
      const wasBaseline = isEqual(priceLevels, initialState?.priceLevels)
      setPriceLevels(recomputedPriceLevels)
      // Fee fill-in is not a user edit. Keep the snapshot in step so the
      // save bar stays hidden until something else changes.
      if (wasBaseline) {
        setInitialState((prev) =>
          prev
            ? {
                ...prev,
                priceLevels: recomputedPriceLevels,
                defaultPriceLevels: recomputedPriceLevels,
              }
            : prev
        )
      }
    }
  }, [
    isEditing,
    event?.fee_structure,
    taxRates,
    event,
    priceLevels,
    initialState?.priceLevels,
    offer?.freeOffer,
  ])

  // remove input error when input field changes
  useEffect(() => {
    resetError('accessCode')
  }, [offer?.accessCode])

  // remove input error when input field changes
  useEffect(() => {
    resetError('discount')
  }, [discount])

  // remove input errors when input field changes
  useEffect(() => {
    resetError(['minQuantity', 'maxQuantity'])
  }, [ticketLimits?.minQuantity])

  // remove input errors when input field changes
  useEffect(() => {
    resetError(['multipleOfQuantity', 'maxQuantity'])
  }, [ticketLimits?.multipleOfQuantity])

  // max quantity resets all error messages - field is the dependant (all fields depend on this)
  useEffect(() => {
    resetError(['minQuantity', 'maxQuantity', 'multipleOfQuantity'])
  }, [ticketLimits?.maxQuantity])

  // remove input error when input field changes
  useEffect(() => {
    resetError('limit')
  }, [ticketLimits?.limit])

  // check if all offer prices are the same as initial offer prices
  const isPriceSameAsInitial = (priceLevels, initialPriceLevels) => {
    // Extracting the arrays of offer prices
    const offerPrices = Object.values(priceLevels)?.map(
      (level) => level.offerPrice
    )
    const initialOfferPrices = Object.values(initialPriceLevels)?.map(
      (initialLevel) => initialLevel.offerPrice
    )

    // Check if both arrays have the same elements
    return (
      offerPrices.length === initialOfferPrices.length &&
      offerPrices.every((price, index) => price === initialOfferPrices[index])
    )
  }

  // check if all offer seats are the same as initial offer seats
  const isSeatsSameAsInitial = (priceLevels, initialPriceLevels) => {
    const getSeats = (levels) => {
      return Object.values(levels)?.map((level) => {
        return level.seats
        // const gaSeats = Object.values(level?.gaSeats)?.flatMap(seats => seats)
        // return
      })
    }

    const allSeats = getSeats(priceLevels)
    const initialSeats = getSeats(initialPriceLevels)

    // Check if both arrays have the same elements
    return (
      allSeats.length === initialSeats.length &&
      allSeats.every((seats, index) => seats === initialSeats[index])
    )
  }

  const updateRequiredFieldErrorStatus = () => {
    setRequiredFieldErrorStatus({
      name: !offer?.name,
      discount:
        pricingOpt?.includes('decrease_by') && !discount && !offer?.freeOffer,
      code: hasAccessCode && !offer.accessCode,
      limit:
        (ticketLimits?.hasMinQuantity && !ticketLimits?.minQuantity) ||
        (ticketLimits?.hasMaxQuantity && !ticketLimits?.maxQuantity) ||
        (ticketLimits?.hasMultipleOfQuantity &&
          !ticketLimits?.multipleOfQuantity) ||
        (hasExactLimit && !ticketLimits?.limit),
    })
  }

  const closeAlert = () => {
    setAlert({ show: false, variant: '', message: '' })
  }

  const handleChange = (e, val = e.target?.value) => {
    if (e.target) setOffer({ ...offer, [e.target.name]: val })
  }

  const zeroOutPriceLevelsForComplimentaryOffer = () => {
    setPriceLevels((prev) => {
      const next = { ...prev }
      for (const key of Object.keys(next)) {
        next[key] = {
          ...next[key],
          basePrice: '0',
          offerPrice: '0',
          fee: '0',
          serviceFee: 0,
          serviceFees: 0,
          ticketFacilityFee: 0,
          paymentProcessingFee: 0,
          salesTax: 0,
          taxPerTicket: 0,
          chargeBackProtection: 0,
          totalDue: 0,
          ticketCostWithFees: 0,
          ticketCostWithFeesAndTax: 0,
          totalFees: 0,
          combinedTaxRate: 0,
        }
      }
      return next
    })
  }

  const handleFreeOfferToggle = (checked) => {
    setOffer((prev) => ({ ...prev, freeOffer: checked }))
    if (checked) {
      setDiscount('')
      setPricingOpt('match_price')
      zeroOutPriceLevelsForComplimentaryOffer()
    } else if (initialState?.priceLevels) {
      setPriceLevels(JSON.parse(JSON.stringify(initialState.priceLevels)))
      setDiscount(initialState.discount ?? '')
      setPricingOpt(initialState.pricingOpt ?? 'match_price')
    }
  }

  const handleTicketLimits = (e, val = e.target?.value) => {
    if (e.target) setTicketLimits({ ...ticketLimits, [e.target.name]: val })
  }

  const handleValid = (e) => {
    const { name } = e.target

    switch (name) {
      case 'discount':
        // always discount off of base price - discount of default price
        if (
          Object.values(initialState?.defaultPriceLevels)?.some(
            (level) =>
              getDiscountedPrice(level?.basePrice, pricingOpt, e.target.value) <
              0
          )
        ) {
          setErrors([
            ...errors,
            {
              field: name,
              message: `Discount cannot make offer price go below 0`,
            },
          ])
        }
        break

      case 'accessCode':
        if (e.target.value !== '' && !e.target.validity.valid) {
          setErrors([
            ...errors,
            {
              field: name,
            },
          ])
        }
        break

      case 'minQuantity':
        if (
          ticketLimits?.minQuantity &&
          parseInt(ticketLimits?.minQuantity) >
            parseInt(ticketLimits?.maxQuantity)
        ) {
          setErrors([
            ...errors,
            {
              field: name,
              message: 'Minimum quantity must be less than maximum quantity',
            },
          ])
        }
        break
      case 'maxQuantity':
        if (ticketLimits?.maxQuantity) {
          if (
            parseInt(ticketLimits?.maxQuantity) <
            parseInt(ticketLimits?.minQuantity)
          ) {
            setErrors([
              ...errors,
              {
                field: name,
                message:
                  'Maximum quantity must be greater than minimum quantity',
              },
            ])
          }
        }
        if (
          ticketLimits?.multipleOfQuantity &&
          !isMultiple(
            parseInt(ticketLimits?.maxQuantity),
            parseInt(ticketLimits?.multipleOfQuantity)
          )
        ) {
          setErrors([
            ...errors,
            {
              field: name,
              message: `Maximum of quantity must be multiple of multiple of quantity (${
                ticketLimits?.multipleOfQuantity
              }) (example: ${getMultiples(
                parseInt(ticketLimits?.multipleOfQuantity)
              )} etc.)`,
            },
          ])
        }
        break
      case 'multipleOfQuantity':
        if (ticketLimits?.multipleOfQuantity) {
          if (
            ticketLimits?.maxQuantity &&
            !isMultiple(
              parseInt(ticketLimits?.maxQuantity),
              parseInt(ticketLimits?.multipleOfQuantity)
            )
          ) {
            setErrors([
              ...errors,
              {
                field: name,
                message: `Multiple of quantity must go into maximum quantity (${
                  ticketLimits?.maxQuantity
                }) evenly (example: ${getDivisors(
                  parseInt(ticketLimits?.maxQuantity)
                )})`,
              },
            ])
          }
          break
        }
        break
      case 'limit':
        if (
          ticketLimits?.limit &&
          (parseInt(ticketLimits?.limit) < 1 ||
            parseInt(ticketLimits?.limit) > 50)
        ) {
          setErrors([
            ...errors,
            {
              field: name,
              message: 'Ticket limit must be a number between 1 and 50',
            },
          ])
        }
        break
      default:
        break
    }
  }

  const isMultiple = (product, divisor) => {
    return product % divisor === 0
  }

  const getMultiples = (divisor, limit = 5) => {
    const multiples = []

    for (let i = 1; i <= limit; i++) {
      multiples.push(divisor * i)
    }

    return multiples
  }

  const getDivisors = (product) => {
    const divisors = []

    // loop through 1 to product
    for (let i = 1; i <= product; i++) {
      for (let j = i; j <= product; j++) {
        if (i * j === product) {
          // if i and j are not the same, add both to array; otherwise just add i
          if (i !== j) {
            divisors.push([i, j])
          } else {
            divisors.push(i)
          }
          break // break out of inner loop when j is a multiplier
        }
      }
    }
    return divisors
  }

  // find error in errors array
  const findError = (fields) => {
    const findObj = (field) => {
      return errors?.find((error) => error.field === field)
    }

    if (Array.isArray(fields)) {
      return fields
        ?.map((field) => findObj(field))
        ?.filter((obj) => obj !== undefined)
    } else {
      return findObj(fields)
    }
  }

  // remove error
  const resetError = (fields) => {
    const foundErrors = findError(fields)
    if (Array.isArray(foundErrors)) {
      const filteredErrors = errors.filter(
        (error) => !foundErrors.some((obj) => obj.field === error.field)
      )
      setErrors(filteredErrors)
    } else {
      setErrors(errors?.filter((error) => error?.field !== foundErrors?.field))
    }
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleCloseDelete = () => setShowDelete(false)

  const handleCloseConfirm = () => setShowConfirm(false)

  const handleLeave = () => {
    if (showFooter) {
      setShowConfirm(true)
    } else {
      handleGoBack()
    }
  }

  const handleRemove = () => {
    removeOffer(offer?.uuid, handleCloseDelete).then(() => {
      setIsChangesMade(true)
      handleGoBack()
    })
  }

  // go to seatmap popup
  const handleShow = (id) => {
    setNewOfferId(id)
    setShow(true)
  }
  const handleClose = () => {
    setShow(false)
    setIsChangesMade(true)
    handleGoBack()
  }

  const handleGoTo = (id) => {
    navigate(`/event/${eventId}/seatmap?id=${id}`)
  }

  // change availability periods active property based on selected
  const getUpdatedAvailabilityPeriods = (periods) => {
    return periods.map(({ id, ...period }) => {
      const updatedPeriod = {
        ...period,
        active: id === availabilityPeriodId,
      }

      // periods that only exist in the browser must be sent without an id so
      // the server creates them instead of overwriting an unrelated component
      if (isLocalPeriodId(id)) return updatedPeriod

      return { ...updatedPeriod, id }
    })
  }

  const getPricingObjectsPayload = () => {
    const entries = Object.entries(priceLevels || {})
    if (offer?.freeOffer) {
      return entries.reduce((acc, [key, level]) => {
        acc[key] = {
          ...level,
          basePrice: '0',
          offerPrice: '0',
          fee: '0',
          serviceFee: 0,
          serviceFees: 0,
          ticketFacilityFee: 0,
          paymentProcessingFee: 0,
          salesTax: 0,
          taxPerTicket: 0,
          chargeBackProtection: 0,
          totalDue: 0,
          ticketCostWithFees: 0,
          ticketCostWithFeesAndTax: 0,
          totalFees: 0,
          combinedTaxRate: 0,
        }
        return acc
      }, {})
    }
    return entries.reduce((acc, [key, level]) => {
      const calculatedFees = calculateFees(
        level,
        event?.fee_structure,
        taxRates,
        event
      )
      const serviceFee =
        calculatedFees?.serviceFee ??
        calculatedFees?.serviceFees ??
        level?.serviceFee ??
        level?.serviceFees ??
        0

      acc[key] = {
        ...level,
        ...calculatedFees,
        serviceFee,
        serviceFees: serviceFee,
      }
      return acc
    }, {})
  }

  const handleSave = (e) => {
    e.preventDefault()

    // if error, don't save
    if (hasRequiredFieldError) {
      scrollToTop()
      return
    }

    const hasError =
      !offer?.name ||
      (hasAccessCode && !offer?.accessCode) ||
      (pricingOpt?.includes('decrease_by') && !discount && !offer?.freeOffer) ||
      (ticketLimits?.hasMinQuantity && !ticketLimits?.minQuantity) ||
      (ticketLimits?.hasMaxQuantity && !ticketLimits?.maxQuantity) ||
      (ticketLimits?.hasMultipleOfQuantity &&
        !ticketLimits?.multipleOfQuantity) ||
      (hasExactLimit && !ticketLimits?.limit)
    if (hasError) {
      updateRequiredFieldErrorStatus()
      setHasRequiredFieldError(hasError)
      scrollToTop()
      setAlert({
        show: true,
        variant: 'danger',
        message:
          'You are missing required subject fields. Please fill out all required fields before continuing.',
      })
      return
    }

    // if other errors
    if (errors?.length > 0) {
      scrollToTop()
      setAlert({
        show: true,
        variant: 'danger',
        message:
          'You have input errors. Please correct all input errors before continuing.',
      })
      return
    }

    setIsSaving(true)

    setIsChangesMade(true)
    const pricingObjectsPayload = getPricingObjectsPayload()

    const sharedData = {
      uuid: offer?.uuid,
      eventUUID: eventId,
      name: offer?.name,
      description: offer?.description,
      am_pricing_objects: pricingObjectsPayload,
      pricing_option: pricingOpt,
      discount: discount || null,
      hasMinQuantity: ticketLimits?.hasMinQuantity,
      minQuantity: ticketLimits?.hasMinQuantity
        ? Number(ticketLimits?.minQuantity)
        : null,
      hasMaxQuantity: ticketLimits?.hasMaxQuantity,
      maxQuantity: ticketLimits?.hasMaxQuantity
        ? Number(ticketLimits?.maxQuantity)
        : null,
      hasMultipleOfQuantity: ticketLimits?.hasMultipleOfQuantity,
      multipleOfQuantity: ticketLimits?.hasMultipleOfQuantity
        ? Number(ticketLimits?.multipleOfQuantity)
        : null,
      limit: Number(ticketLimits?.limit) || null,
      isHidden: offer?.isHidden,
      isSoldOut: offer?.isSoldOut,
      freeOffer: !!offer?.freeOffer,
      redeemWithVouchersOnline: !!offer?.redeemWithVouchersOnline,
    }
    // new offer
    if (!isSpecialtyOffer) {
      const data = {
        ...sharedData,
        isDefaultOffer: isStandard,
        inventoryType: inventory?.type,
        color: inventory?.color,
        seats: inventory?.seats,
        gaSeats: inventory?.gaSeats,
        availability: getUpdatedAvailabilityPeriods(offer?.availabilityPeriods),
        accessCode: offer?.accessCode || null,
      }

      createOrEditOffers(data)
        .then((res) => {
          setIsSaving(false)

          // editing existing offer
          if (isEditing) {
            handleEditSuccess()
            // creating new offer
          } else {
            if (!isSaving) {
              if (inventory?.type === 'exclusive') {
                handleShow(res?.data?.id)
              } else {
                handleGoBack()
              }
            }
          }
        })
        .catch((err) => {
          console.error(err)
          handleSaveError()
        })
    } else {
      const data = {
        ...sharedData,
        baseOfferId: baseOffer?.id,
        priceAdjustment,
      }

      createOrEditConnectedOffer(data)
        .then(() => {
          setIsSaving(false)

          // editing existing offer
          if (isEditing) {
            handleEditSuccess({ baseOffer, priceAdjustment })
          } else {
            handleGoBack()
          }
        })
        .catch((err) => {
          console.error('Error creating discount:', err)
          handleSaveError()
        })
    }
  }

  // shared save edit success function
  const handleEditSuccess = (additionalState = {}) => {
    // save initial state again if editing to check whether to show save buttons
    saveInitialState(
      offer,
      inventory,
      priceLevels,
      priceLevels,
      pricingOpt,
      discount,
      availabilityPeriodId,
      hasAccessCode,
      ticketLimits?.hasMinQuantity,
      ticketLimits?.minQuantity,
      ticketLimits?.hasMaxQuantity,
      ticketLimits?.maxQuantity,
      ticketLimits?.hasMultipleOfQuantity,
      ticketLimits?.multipleOfQuantity,
      hasExactLimit,
      ticketLimits?.limit,
      additionalState
    )

    scrollToTop()
    setAlert({
      show: true,
      variant: 'success',
      message: 'This offer has been updated.',
    })
  }

  // shared save error function
  const handleSaveError = () => {
    setIsSaving(false)
    scrollToTop()
    setAlert({
      show: true,
      variant: 'danger',
      message: 'Unable to save offer. Please try again.',
    })
  }

  const saveInitialState = (
    offer,
    inventory,
    defaultPriceLevels,
    priceLevels,
    pricingOpt,
    discount,
    periodId,
    hasAccessCode,
    hasMinQuantity,
    minQuantity,
    hasMaxQuantity,
    maxQuantity,
    hasMultipleOfQuantity,
    multipleOfQuantity,
    hasExactLimit,
    limit,
    additionalState
  ) => {
    setInitialState({
      offer,
      inventory,
      defaultPriceLevels,
      priceLevels,
      pricingOpt,
      discount,
      availabilityPeriodId: periodId,
      hasAccessCode,
      hasExactLimit,
      ticketLimits: {
        hasMinQuantity,
        minQuantity,
        hasMaxQuantity,
        maxQuantity,
        hasMultipleOfQuantity,
        multipleOfQuantity,
        limit,
      },
      ...additionalState,
    })
  }

  const getOpenOffers = (offers) => {
    const openOffers = offers?.filter(
      (offer) => offer?.inventoryType === 'open'
    )

    // update availability periods for all open offers based on standard admission
    const updatedOffers = openOffers?.map((offer) => {
      const updatedAvailabilityPeriods = getAvailabilityPeriods(offer)
      return { ...offer, availability: updatedAvailabilityPeriods }
    })

    // include offers that have not ended
    // offers without an active period or end date can't be evaluated, so they're excluded
    return updatedOffers?.filter((offer) => {
      const endDate = offer?.availability?.find((period) => period.active)?.ends
      const end = getTimezoneDate(endDate, event?.timezone)

      if (!end) return false

      return end.isAfter(getNowInTimezone(event?.timezone))
    })
  }

  const getTitle = () => {
    let action = 'Create'

    if (isSpecialtyOffer) action = 'Create specialty'
    if (id && canEdit) action = 'Edit'
    else if (!canEdit) action = 'View'

    return `${action} offer`
  }

  // show access code if not Standard Admission offer and not discounted offer
  const shouldShowAccessCode = !isStandard && !isSpecialtyOffer

  return (
    <>
      <div className="position-relative">
        <section className="event-form">
          <Row className="flex-nowrap">
            <Col xs={2}>
              <BackButton size="sm" handleGoBack={handleLeave} />
            </Col>
            <Col xs={8} className="m-0 p-0 wrapper">
              <WarningCard
                text="Once this offer is on sale, certain fields cannot be edited. If you require changes, please reach out to your client support representative for assistance"
                variant="primary"
              />
              {alert.show && (
                <>
                  <Alert variant={alert.variant} className="mb-5">
                    <p>{alert.message}</p>
                  </Alert>
                </>
              )}
              <header className="section-header section-heading section-heading--secondary">
                <h1>{getTitle()}</h1>
              </header>
              <Form onSubmit={handleSave}>
                <Card body className="card--light card--md">
                  <Details
                    isStandard={isStandard}
                    canEdit={canEdit}
                    offer={offer}
                    requiredFieldErrorStatus={requiredFieldErrorStatus}
                    handleChange={handleChange}
                  />
                </Card>
                {isSpecialtyOffer && (
                  <Card body className="card--light card--md">
                    <OpenOffers
                      isEditing={isEditing}
                      offers={getOpenOffers(offers)}
                      baseOffer={baseOffer}
                      setBaseOffer={setBaseOffer}
                      eventTimezone={event?.timezone}
                      getAvailabilityPeriods={getAvailabilityPeriods}
                    />
                  </Card>
                )}
                {!isSpecialtyOffer && (
                  <Card body className="card--light card--md">
                    <Inventory
                      isEditing={isEditing}
                      offerName={offer?.name}
                      openInventory={initialState?.inventory}
                      inventory={inventory}
                      setInventory={setInventory}
                      offers={offers}
                      holds={event?.inventory?.holds}
                      kills={event?.inventory?.kills}
                      tickets={event?.tickets}
                    />
                  </Card>
                )}
                <Card body className="card--light card--md">
                  <PricingFees
                    opt={pricingOpt}
                    setOpt={setPricingOpt}
                    discount={discount}
                    setDiscount={setDiscount}
                    levels={priceLevels}
                    setLevels={setPriceLevels}
                    inventory={inventory}
                    standardAdmissionOfferHasInventory={
                      standardAdmissionOfferHasInventory
                    }
                    canEdit={canEdit}
                    isEditing={isEditing}
                    taxRates={taxRates}
                    feeStructure={event?.fee_structure}
                    isStandard={isStandard}
                    isSpecialtyOffer={isSpecialtyOffer}
                    offer={offer}
                    onToggleFreeOffer={handleFreeOfferToggle}
                    requiredFieldErrorStatus={requiredFieldErrorStatus}
                    errors={errors}
                    findError={findError}
                    handleValid={handleValid}
                    event={event}
                  />
                </Card>
                {isSpecialtyOffer &&
                  user?.user?.email === 'harrison@blocktickets.xyz' && (
                    <Card body className="card--light card--md">
                      <Form.Group className="mb-3">
                        <Form.Label>Price Adjustment</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>$</InputGroup.Text>
                          <Form.Control
                            type="number"
                            placeholder="Enter amount (+ for increase, - for discount)"
                            value={priceAdjustment || ''}
                            onChange={(e) => setPriceAdjustment(e.target.value)}
                            step="0.01"
                            disabled={!canEdit}
                          />
                        </InputGroup>
                        <Form.Text className="text-muted">
                          Use positive numbers for price increases, negative for
                          discounts
                        </Form.Text>
                      </Form.Group>
                    </Card>
                  )}
                {!isSpecialtyOffer && (
                  <Card body className="card--light card--md">
                    <Availability
                      openOffers={getOpenOffers(offers)}
                      isStandard={isStandard}
                      inventoryType={inventory?.type}
                      event={event}
                      offers={offers}
                      offer={offer}
                      setOffer={setOffer}
                      selected={availabilityPeriodId}
                      setSelected={setAvailabilityPeriodId}
                      isEditing={isEditing}
                      canEdit={canEdit}
                    />
                  </Card>
                )}
                {shouldShowAccessCode && (
                  <Card body className="card--light card--md">
                    <AccessCode
                      offer={offer}
                      setOffer={setOffer}
                      errors={errors}
                      canEdit={canEdit}
                      initialState={initialState?.offer?.accessCode}
                      setHasAccessCode={setHasAccessCode}
                      requiredFieldErrorStatus={requiredFieldErrorStatus}
                      handleChange={handleChange}
                      handleValid={handleValid}
                      findError={findError}
                    />
                  </Card>
                )}
                {!isStandard && (
                  <Card body className="card--light card--md">
                    <TicketLimits
                      globalTicketLimit={event?.globalTicketLimit}
                      limits={ticketLimits}
                      setLimits={setTicketLimits}
                      initialState={initialState?.ticketLimits}
                      errors={errors}
                      requiredFieldErrorStatus={requiredFieldErrorStatus}
                      canEdit={canEdit}
                      setHasExactLimit={setHasExactLimit}
                      handleChange={handleTicketLimits}
                      handleValid={handleValid}
                      findError={findError}
                    />
                  </Card>
                )}
              </Form>
              {redeemFlexTicketsOnline && (
                <Card body className="mt-5 card--light card--md">
                  <Form.Check
                    type="switch"
                    id="offer-redeem-vouchers"
                    name="redeemWithVouchersOnline"
                    label="Redeem flex tickets"
                    checked={!!offer?.redeemWithVouchersOnline}
                    onChange={(e) => {
                      handleChange(e, e.target.checked)
                    }}
                    disabled={!canEdit}
                    className="form-switch--with-desc gap-lg"
                  />
                  <small className="subtitle subtitle--dark form-switch--with-desc-subtitle gap-lg">
                    Fans can redeem flex ticket codes for this offer at
                    checkout. These seats stay available for regular purchase.
                  </small>
                </Card>
              )}
              {!isStandard && (
                <Card body className="mt-5 card--light card--md">
                  {isSpecialtyOffer && baseOffer?.isHidden && (
                    <WarningCard
                      text={`The ${baseOffer?.name} offer is hidden. This offer is automatically hidden. To make this offer visible to the public, make the ${baseOffer?.name} offer visible`}
                      variant="danger"
                    />
                  )}
                  <Form.Check
                    type="switch"
                    id="offer-visibility"
                    name="isHidden"
                    label="Hide offer"
                    checked={!!offer?.isHidden}
                    onChange={(e) => {
                      handleChange(e, e.target.checked)
                    }}
                    disabled={baseOffer?.isHidden || !canEdit}
                    className="form-switch--with-desc gap-lg"
                  />
                  <small className="subtitle subtitle--dark form-switch--with-desc-subtitle gap-lg">
                    The offer won't be visible to public. You can undo this
                    action anytime
                  </small>
                </Card>
              )}
              {/* DONT ALLOW DELETE IF STATUS IS PUBLISHING!!!
                            {
                                isEditing && canEdit && !isStandard && (!isEventPublishing || event?.status !== 'publishing') && (
                                    <Button
                                        variant='link'
                                        className='mt-4 text-danger icon-button btn-delete icon-button--danger'
                                        onClick={() => setShowDelete(true)}
                                    >
                                        Delete this offer
                                    </Button>
                                )
                            } */}
            </Col>
          </Row>
          {showFooter && (
            <CreateEventButtons
              isEditing={id}
              page="Offers"
              showGoBack={true}
              isSaving={isSaving}
              handleGoBack={handleGoBack}
              handleSave={handleSave}
            />
          )}
        </section>
      </div>

      <GoToSeatMapModal
        show={show}
        id={newOfferId}
        handleClose={handleClose}
        handleClick={handleGoTo}
      />

      <DeleteModal
        show={showDelete}
        entity="offer"
        isRemoving={isRemoving}
        handleDelete={handleRemove}
        handleClose={handleCloseDelete}
      />

      <ConfirmLeaveModal
        show={showConfirm}
        handleGoBack={handleGoBack}
        handleClose={handleCloseConfirm}
      />
    </>
  )
}

/* {isStandard && (
          <Card body className="card--light card--md">
              <PricingLevelDescription
                  priceLevels={priceLevels}
                  setPriceLevels={setPriceLevels}
                  isDisabled={offer?.status === 'ended'}
              />
          </Card>
      )} */
